import { Component, Input, OnInit } from '@angular/core';
import { GStatic } from '../../../services/GStatic';
import { MatDialog } from '@angular/material/dialog';
import { NotificationInstructionsDialogComponent } from './notification-instructions-dialog/notification-instructions-dialog.component';
import { GlobalService } from '../../../services/global.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() title: string = '';
  @Input() loading: number = 0;
  @Input() navbar: boolean = false;
  @Input() floatingButton: boolean = false;
  isMobile: boolean = false;

  constructor(
    private dialog: MatDialog,
    private _globalService: GlobalService,
  ) {}

  ngOnInit(): void {
    this.isMobile = GStatic.isMobile();
  }

  showNotificationBanner: boolean = true;

  requestNotifications() {
    // Check if the Notification API is supported
    if (this._globalService.isNotificationsSupported()) {
      // Check the current notification permission
      if (Notification.permission === 'granted') {
        // You can send a test notification here if you want
        // Optionally, send a test notification
        new Notification('Test Notification', {
          body: 'Notifications are working fine!',
        });
      } else if (Notification.permission === 'denied' || Notification.permission === 'default') {
        // If permission is denied, show a custom message guiding users to re-enable notifications
        this.showNotificationInstructions();
      }
    } else {
      // Provide alternative functionality if notifications are unsupported
    }
  }

  showNotificationInstructions() {
    // Open the dialog with instructions
    this.dialog.open(NotificationInstructionsDialogComponent, {
      width: '500px',
    });
  }

  closeNotificationBanner() {
    this.showNotificationBanner = false; // Hide banner when close button is clicked
  }

  checkNotificationGranted() {
    if (this._globalService.isNotificationsSupported()) {
      if (Notification.permission === 'denied' || Notification.permission === 'default') {
        return true;
      }
    } else {
      return false;
    }
  }
}
